import { getDeviceInfo } from "./getDeviceInfo";
import { compareVersion } from "./utils";
import { hAppEnum, hDtEnum } from "./types/enum";
const showKeyboardInputView = (args) => {
  const params = {
    initContent: (args == null ? void 0 : args.initContent) || "",
    keyboardType: (args == null ? void 0 : args.keyboardType) || 0
  };
  return new Promise((resolve, reject) => {
    getDeviceInfo().then((res) => {
      if (res.h_app === hAppEnum.lite && compareVersion(
        res.h_av,
        {
          [hDtEnum.ios]: "4.30.2",
          [hDtEnum.android]: "4.30.1"
        }[res.h_dt]
      )) {
        window.HiyaJSBridge.callHandler(
          "showKeyboardInputView",
          params,
          (res2) => {
            resolve({ inputContent: res2.inputContent });
          }
        );
      } else {
        reject("error: iOS:4.30.2 Android:4.30.1 lite包独有");
      }
    });
  });
};
showKeyboardInputView.text = async (initContent) => {
  const res = await showKeyboardInputView({
    initContent,
    keyboardType: 0
  });
  return res.inputContent || "";
};
showKeyboardInputView.number = async (initContent) => {
  const res = await showKeyboardInputView({
    initContent: String(initContent),
    keyboardType: 1
  });
  const inputContent = Number(res.inputContent);
  return {
    returnNum: inputContent || Number(res.inputContent) || 0,
    err: Number.isNaN(inputContent)
  };
};
showKeyboardInputView.float = async (initContent) => {
  const res = await showKeyboardInputView({
    initContent: String(initContent),
    keyboardType: 2
  });
  const inputContent = Number(res.inputContent);
  return {
    returnNum: inputContent || Number(res.inputContent) || 0,
    err: Number.isNaN(inputContent)
  };
};
export {
  showKeyboardInputView
};
